import { reactive, Div, Label } from 'alkali'
import PhraseInput from '../generic/PhraseInput'
import { selectedCharacteristicIds, selectedTreatmentIds } from 'model/EvidenceSearch'
import { isRoot } from './FilterPane'
export let characteristicInput



export const HasFilter = BaseClass => class extends BaseClass {
	addTerm: Function
	attributeType: string
	renderHeader() {
		let selectedTerm = reactive('')
		let content = reactive('')
		this.headerNode.append(Div('.filter-search', [
			PhraseInput.with('.phrase-input', {
				title: '',
				placeholder: this.placeholder,
				termType: this.attributeType,
				valueVar: selectedTerm,
				content,
			}),
			Label(`#${this.attributeType}-label`, [this.label])
		], {
			onkeydown: (event) => {
				if (event.keyCode == 13) {
					addSelected()
				}
			},
		}))
		const addSelected = () => {
			setTimeout(() => {
				let term = selectedTerm.valueOf()
				if (term) {
					term.fromText = true
					this.addTerm(term)
					this.queueRefresh()
				}
				selectedTerm.put() // clear the term
				$('.phrase-input', this).typeahead('val', '')
			}, 10)
		}
		$(this.headerNode).bind('typeahead:select', addSelected)
		this.attributeType == 'characteristic' ? characteristicInput = this.headerNode : null
	}
}